import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React, { Suspense } from 'react';
import DatePicker$1 from './GregorianCalendar/GregorianCalendar.js';

var _excluded = ["autoOk", "className", "data-testid", "disabled", "disableFieldInfo", "error", "errorText", "format", "hintText", "highlight", "id", "label", "location", "noValidate", "onError", "onUpdate", "placeholder", "required", "type", "yearRange", "value"];
var RetailCalendar = /*#__PURE__*/React.lazy(function () {
  return import('./RetailCalendar/index.js');
});
function RawDatePicker(_ref) {
  var _ref$autoOk = _ref.autoOk,
    autoOk = _ref$autoOk === void 0 ? true : _ref$autoOk,
    className = _ref.className,
    dataTestId = _ref['data-testid'],
    disabled = _ref.disabled,
    disableFieldInfo = _ref.disableFieldInfo,
    error = _ref.error,
    errorText = _ref.errorText,
    format = _ref.format,
    hintText = _ref.hintText,
    _ref$highlight = _ref.highlight,
    highlight = _ref$highlight === void 0 ? false : _ref$highlight,
    id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Date' : _ref$label,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'bottom-left' : _ref$location,
    _ref$noValidate = _ref.noValidate,
    noValidate = _ref$noValidate === void 0 ? false : _ref$noValidate,
    onError = _ref.onError,
    onUpdate = _ref.onUpdate,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'gregorian' : _ref$type,
    yearRange = _ref.yearRange,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isRetail = type === 'retail' || type === 'retail-range';
  var isGregorian = type === 'gregorian' || type === 'gregorian-range';
  var finalClasses = classnames('C-DatePicker', _defineProperty(_defineProperty({}, "--location-".concat(location), location), "--type-".concat(type), type), className);
  if (otherProps['onChange']) {
    console.error('Hey Canvas User! DatePicker does not support onChange events, please use onUpdate.');
    return;
  }
  if (type === 'retail' && onError) {
    console.error('Hey Canvas User! The retail DatePicker does not support onError.');
    return;
  }
  if (type === 'retail' && format) {
    console.error('Hey Canvas User! The retail DatePicker does not support the format prop.');
    return;
  }
  if (!isGregorian && !isRetail) {
    console.error('Hey Canvas User! The retail DatePicker expects the type prop to have one of the following values retail, retail-range, gregorian, or gregorian-range.');
    return;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: finalClasses,
    "data-testid": dataTestId
  }, isRetail && /*#__PURE__*/React.createElement(Suspense, null, /*#__PURE__*/React.createElement(RetailCalendar, _extends({
    highlight: highlight,
    "data-testid": dataTestId,
    id: id,
    label: label,
    placeholder: placeholder,
    autoOk: autoOk,
    required: required,
    disabled: !!disabled // not undefined only true/false
    ,
    value: value,
    error: error,
    errorText: errorText,
    hintText: hintText,
    onChange: function onChange() {} // prevents warning, we're smarter than react
    ,
    onUpdate: onUpdate,
    noValidate: noValidate,
    disableFieldInfo: disableFieldInfo,
    yearRange: yearRange,
    type: type
  }, otherProps))), isGregorian && /*#__PURE__*/React.createElement(DatePicker$1, _extends({
    autoOk: autoOk,
    "data-testid": dataTestId,
    disabled: !!disabled // not undefined only true/false
    ,
    error: error,
    errorText: errorText,
    format: format,
    highlight: highlight,
    hintText: hintText,
    id: id,
    label: label,
    onChange: function onChange() {} // prevents warning, we're smarter than react
    ,
    onError: onError,
    noValidate: noValidate,
    onUpdate: onUpdate,
    placeholder: placeholder,
    required: required,
    value: value,
    disableFieldInfo: disableFieldInfo,
    yearRange: yearRange,
    type: type
  }, otherProps)));
}
RawDatePicker.displayName = 'DatePicker';
var DatePicker = /*#__PURE__*/React.memo(RawDatePicker);

export { DatePicker as default };
